var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticStyle:{"height":"100%"},attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"5"}},[_c('div',{staticClass:"card"},[_c('BlockSettings',{attrs:{"hideButtons":true}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }